export const poLibrary = {
  secureConnectionMobile: 410,
  secureConnectionFusion: 413,
  secureConnectionInternet: 411,
  eHealthPersonal: '1071',
  eHealthFamily: '1072',
  bonu5GB: '72',
  bonu10GB: '80',
  bonu20GB: '70',
  bonu40GB: '91',
  bonuPromo5GB: '580',
  bonuPromo30GB: '730',
  bonuUnlimited: '969',
  // POs compatibles con el acceso al configurador de fusión
  fibraOptica600Mb: '155',
  fibraOptica100Mb: '156',
  fibraOpticaAsimetrica600Mb: '160',
  fibraOpticaAsimetrica100Mb: '161',
  movistarConecta: '575',
  bafSencilloFibra300Mb: '576',
  bafSencilloFibra300MbSimetrica: '577',
  movistarConectaMAX: '1000',
  //
};
export default poLibrary;

export const rent2rent = {
  devicesTypeR2R: 1,
  devicesTypeAdditionalR2R: 2,
};
